module.exports = __webpack_public_path__ + "img/ver2.f7af9e26.jpg";